module.exports = __webpack_public_path__ + "0aebcf53c9fdccfc55605e484c4e68cf.glb";